import {Navigate} from 'react-router-dom';
import RoutesProtection from './routes-protection.tsx';
import App from '../App.tsx';

export const routes = [
    {
        path: 'login',
        lazy: async () => {
            const {default: Login} = await import('../../pages/login/login-page.tsx');
            return {Component: Login};
        },
    },
    {
        path: '/',
        element: (
            <RoutesProtection>
                <App/>
            </RoutesProtection>
        ),
        children: [
            {
                path: '/',
                element: <Navigate to='/main' replace/>, // Редирект с корня
            },
            {
                path: 'main',
                lazy: async () => {
                    const {default: Main} = await import('../../pages/main/main-page.tsx');
                    return {Component: Main};
                },
            },
            {
                path: 'articles',
                lazy: async () => {
                    const {default: Articles} = await import('../../pages/articles/articles-page.tsx');
                    return {Component: Articles};
                },
            },
            {
                path: 'sites',
                lazy: async () => {
                    const {default: Sites} = await import('../../pages/sites/sites-page.tsx');
                    return {Component: Sites};
                },
            },
        ],
    },
    {
        path: '*',
        element: <Navigate to='/main' replace/>, // Если пользователь авторизован, но ввёл несуществующий маршрут → на /main
    },
];
